import { MentionsPlugin } from "../../../sked-editor/social-mention/mention-plugin";
import { $createSkedSocialMentionNode } from "../sked-social-mention";
import { isSuggestOptionFbPage } from "../../utils/autocomplete";
import { SuggestFunc } from "../types";
import { SkedMentionBox, SkedMentionItem } from "./sked-mention-box";
import { LocalStorageCache } from "./local-storage-cache";
import uniqBy from "lodash/uniqBy";
import { PUNCTUATION } from "../../../sked-editor/type-ahead/type-ahead-plugin";
const fbCache = new LocalStorageCache("fb-page-mention-cache", 20);
export const FbMentionSearchPlugin = ({
  lookupFunc,
}: {
  lookupFunc: SuggestFunc;
}) => {
  return (
    <MentionsPlugin
      lookupConfig={{
        allowWhitespace: true,
        minLength: 0,
        punctuation: PUNCTUATION.replace(".", "").replace("-", ""),
      }}
      onSelectItem={(item) => {
        fbCache.addItem(item);
      }}
      menuBoxBehavior={{
        nodeConversion: {
          type: "mention-node",
          trailingSpace: true,
          convertFunc: (item) => {
            return {
              platformStructureText: `@[${item.key}](${item.displayName})`,
              displayText: item.displayName,
            };
          },
          $createMentionNode: $createSkedSocialMentionNode,
        },

        dataFetcher: async (
          lookupText: string | null | undefined
        ): Promise<SkedMentionItem[]> => {
          if (!lookupText) {
            return [];
          }
          const rs = await lookupFunc(lookupText || "");

          return rs
            .filter((c) => isSuggestOptionFbPage(c))
            .map(
              (c) =>
                ({
                  key: c.id,
                  displayName: c.name,
                  profileImg: c.picture,
                  info: c.id,
                }) satisfies SkedMentionItem as SkedMentionItem
            );
        },
        dataResolver: (
          items: SkedMentionItem[],
          lookupText: string | null | undefined
        ) => {
          const cacheRs = fbCache.getItems();
          return uniqBy(
            [
              ...items,
              ...cacheRs.filter((c) =>
                c.displayName
                  .toLowerCase()
                  .includes((lookupText || "").toLowerCase())
              ),
            ],
            (c) => c.key
          );
        },
        renderMenuBox: (props, { lookupText }) => {
          return (
            <SkedMentionBox
              {...props}
              headingText="Search accounts"
              displayConfig={{
                showProfileImage: true,
                showInfo: true,
              }}
              highlightBehavior={{
                matchingOn: "contains",
                searchText: lookupText,
              }}
            />
          );
        },

        maxItemsToShow: 100,
      }}
    />
  );
};
